import * as yup from "yup";

const schema = yup.object().shape({
  email: yup.string(),
  user: yup.string(),
  password: yup.string().required('Campo obrigatório'),
});

export default schema;
